import api from './api';

export const serviceService = {
  /**
   * Obtener todos los servicios
   */
  async getServices(params = {}) {
    try {
      console.log('📡 [serviceService] Enviando petición GET a:', '/api/services');
      console.log('📋 [serviceService] Parámetros:', params);
      
      const response = await api.get('/services', { params });
      
      console.log('✅ [serviceService] Respuesta recibida exitosamente');
      console.log('📦 [serviceService] Response.data:', response.data);
      console.log('🔢 [serviceService] Cantidad de servicios:', Array.isArray(response.data?.data) ? response.data.data.length : 'No es un array');
      
      return response.data;
    } catch (error) {
      console.error('❌ [serviceService] Error al obtener servicios:', error);
      console.error('📊 [serviceService] Error.response:', error.response);
      console.error('📋 [serviceService] Error.response?.data:', error.response?.data);
      throw error;
    }
  },
  
  /**
   * Obtener un servicio por ID
   */
  async getService(id) {
    try {
      console.log('📡 [serviceService] Enviando petición GET a:', `/api/services/${id}`);
      
      const response = await api.get(`/services/${id}`);
      
      console.log('✅ [serviceService] Servicio obtenido exitosamente');
      console.log('📦 [serviceService] Response.data:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('❌ [serviceService] Error al obtener servicio:', error);
      console.error('📊 [serviceService] Error.response:', error.response);
      throw error;
    }
  },
  
  /**
   * Crear un nuevo servicio
   */
  async createService(data) {
    try {
      console.log('📡 [serviceService] Enviando petición POST a:', '/api/services');
      console.log('📦 [serviceService] Datos a enviar:', data);
      
      const response = await api.post('/services', data);
      
      console.log('✅ [serviceService] Servicio creado exitosamente');
      console.log('📦 [serviceService] Response.data:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('❌ [serviceService] Error al crear servicio:', error);
      console.error('📊 [serviceService] Error.response:', error.response);
      console.error('📋 [serviceService] Error.response?.data:', error.response?.data);
      throw error;
    }
  },
  
  /**
   * Actualizar un servicio
   */
  async updateService(id, data) {
    try {
      console.log('📡 [serviceService] Enviando petición PUT a:', `/api/services/${id}`);
      console.log('📦 [serviceService] Datos a enviar:', data);
      
      const response = await api.put(`/services/${id}`, data);
      
      console.log('✅ [serviceService] Servicio actualizado exitosamente');
      console.log('📦 [serviceService] Response.data:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('❌ [serviceService] Error al actualizar servicio:', error);
      console.error('📊 [serviceService] Error.response:', error.response);
      console.error('📋 [serviceService] Error.response?.data:', error.response?.data);
      throw error;
    }
  },
  
  /**
   * Eliminar un servicio
   */
  async deleteService(id) {
    try {
      console.log('📡 [serviceService] Enviando petición DELETE a:', `/api/services/${id}`);
      
      const response = await api.delete(`/services/${id}`);
      
      console.log('✅ [serviceService] Servicio eliminado exitosamente');
      console.log('📦 [serviceService] Response.data:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('❌ [serviceService] Error al eliminar servicio:', error);
      console.error('📊 [serviceService] Error.response:', error.response);
      throw error;
    }
  },
};







